// extracted by mini-css-extract-plugin
module.exports = {"bio-card":"styles__bio-card___392Aa","bio-card__header":"styles__bio-card__header___ycr7-"};